import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { Button } from "../Form";
import { setExpiredModalOpen } from "../../redux/features/expiredModalSlice";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";

const SectionExpiredModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ allowed here

  const expiredModalOpen = useSelector(
    (state) => state.expiredModal.expiredModalOpen
  );
  // console.log({ expiredModalOpen });

  const handleClose = () => dispatch(setExpiredModalOpen(false));

  return (
    <>
      {expiredModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
          onClick={() => {
            handleClose();
            dispatch(setAuthModalOpen(true)); // open AuthModal again
          }}
        >
          <div
            className="relative w-full max-w-md bg-dry dark:bg-black rounded-lg shadow-lg p-6 m-4 border border-redlight"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => {
                handleClose();
                dispatch(setAuthModalOpen(true)); // open AuthModal again
                navigate("/"); // ✅ navigate here, where hooks are allowed
              }}
              className="absolute top-4 right-4 text-text dark:text-white hover:text-red-500"
            >
              &times;
            </button>

            <h2 className="text-xl font-bold text-center mb-4 text-text dark:text-white">
              Session Expired
            </h2>
            <hr className="max-w-[100px] m-auto my-2 border border-border" />
            <p className="text-sm text-center mt-2 mb-6 text-textGray dark:text-gray-300">
              For security reasons, your login session has expired. Please sign
              in again.
            </p>

            <Button
              label="Sign In"
              onClick={() => {
                handleClose();
                dispatch(setAuthModalOpen(true)); // open AuthModal again
                // navigate("/"); // ✅ navigate here, where hooks are allowed
              }}
              className="w-full bg-redlight hover:bg-reddark hover:text-text text-text py-2 rounded"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SectionExpiredModal;
